import {
  Allocation,
  AllocationBulkPayload,
  AllocationCreatePayload,
} from 'api/resource-management/types';
import { BulkActionPayloadMap } from '../types';

const emptyBulkActionPayload = (): BulkActionPayloadMap => ({
  create: {},
  update: {},
  delete: {},
});

export const toBulkActionPayload = (
  actionsMap: BulkActionPayloadMap,
): AllocationBulkPayload => ({
  create: Object.values(actionsMap.create),
  update: Object.values(actionsMap.update),
  delete: Object.values(actionsMap.delete),
});

export const bulkActionsMapActions = (): {
  createAllocation: (
    createPayload: AllocationCreatePayload,
    tempId: string | number,
  ) => void;
  updateAllocation: (newPayload: Allocation) => void;
  deleteAllocation: (payload: Allocation) => void;
  asPayload: () => AllocationBulkPayload;
  actionsMap: BulkActionPayloadMap;
} => {
  const actionsMap = emptyBulkActionPayload();

  const createAllocation = (
    createPayload: AllocationCreatePayload,
    tempId: string | number,
  ) => {
    actionsMap.create[tempId] = createPayload;
  };
  const updateAllocation = (payload: Allocation) => {
    const updatePayload = actionsMap.update[payload.id] ?? {};

    actionsMap.update[payload.id] = {
      ...updatePayload,
      ...payload,
    };
  };
  const deleteAllocation = (payload: Allocation) => {
    actionsMap.delete[payload.id] = payload;
  };
  const asPayload = (): AllocationBulkPayload =>
    toBulkActionPayload(actionsMap);

  return {
    createAllocation,
    updateAllocation,
    deleteAllocation,
    asPayload,
    actionsMap,
  };
};
